import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { Megaphone, TrendingUp, Users, Target } from "lucide-react";
import digitalMarketingBanner from "../../../images/webtechhome/digital-marketing.jpg";

const trustMetrics = [
  { value: 300, suffix: "+", label: "Campaigns Launched", icon: Megaphone },
  { value: 150, suffix: "+", label: "Happy Clients", icon: Users },
  { value: 3, suffix: "x", label: "Avg. ROI Growth", icon: TrendingUp },
  { value: 95, suffix: "%", label: "Client Retention", icon: Target },
];

const DmHero: React.FC = () => (
  <section className="dm-hero" aria-labelledby="dm-hero-title">
    <div className="dm-hero__mesh" aria-hidden="true" />
    <div className="dm-particles" aria-hidden="true">
      {Array.from({ length: 18 }, (_, i) => (
        <span key={i} />
      ))}
    </div>

    <div className="dm-container dm-hero__grid">
      <motion.div
        className="dm-hero__content"
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <span className="dm-eyebrow">
          <Megaphone size={14} aria-hidden="true" />
          Digital Marketing Services
        </span>

        <h1 id="dm-hero-title">
          Grow Your Brand With{" "}
          <span className="dm-gradient-text">Data-Driven</span>{" "}
          <span className="dm-gradient-text">Digital Marketing</span>
        </h1>

        <p>
          From SEO and paid ads to social media and content marketing — we help
          businesses attract the right audience, generate qualified leads, and
          achieve measurable online growth.
        </p>

        <div className="dm-hero__actions">
          <Link className="dm-btn dm-btn--primary" to="/contact">
            Get Free Strategy Call
            <ArrowIcon />
          </Link>
          <Link className="dm-btn dm-btn--ghost" to="/project">
            View Case Studies
            <ArrowIcon />
          </Link>
        </div>

        <div className="dm-hero__metrics">
          {trustMetrics.map((metric) => {
            const Icon = metric.icon;
            return (
              <div className="dm-metric" key={metric.label}>
                <span className="dm-metric__icon" aria-hidden="true">
                  <Icon size={18} />
                </span>
                <strong>
                  <CountUp end={metric.value} duration={2.2} enableScrollSpy scrollSpyOnce />
                  {metric.suffix}
                </strong>
                <span>{metric.label}</span>
              </div>
            );
          })}
        </div>
      </motion.div>

      <div className="dm-hero__visual">
        <motion.div
          className="dm-hero__banner-wrap"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
        >
          <img
            src={digitalMarketingBanner}
            alt="Digital marketing analytics dashboard with campaign performance metrics"
            className="dm-hero__banner"
          />
        </motion.div>
      </div>
    </div>
  </section>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DmHero;
